<template>
  <div class="move-house-modal flex-side">
    <div class="source-view border-1 border-r-8">
      <div class="store-info h-40 p-10-15">门店：{{moveStoreName}}</div>
      <div class="filter-view p-10-15">
        <label>房型：</label>
        <el-select
          v-model="currentRoomType"
          clearable
          class="w-200"
          @change="roomTypeChange"
        >
          <el-option
            v-for="item of roomTypeList"
            :key="item.id"
            :value="item.id"
            :label="item.roomTypeName"
          ></el-option>
        </el-select>
      </div>
      <r-table
        :columns="tableColumn"
        :dataSource="roomDataList"
        :options="options"
        :showPagination="false"
        @selection-change="handleLeftSelectChange"
      >
      </r-table>
    </div>
    <div class="flex-c-center c-operate operations">
      <el-button @click="addItem" :class="{ disabled: !sourceTableSelection.length }" type="primary" style="width: 100px;">
        <el-icon><arrow-right /></el-icon>
      </el-button>
      <div style="height: 8px;"></div>
      <el-button @click="delItem" :class="{ disabled: !targetTableSelection.length }" type="primary" style="width: 100px;">
        <el-icon><arrow-left /></el-icon>
      </el-button>
    </div>
    <div class="target-view border-1 border-r-8">
      <div class="filter-view p-10-15">
        <label>门店：</label>
        <el-select v-model="currentStoreId" clearable>
          <el-option
            v-for="item of storeDataList"
            :key="item.id"
            :value="item.id"
            :label="item.storeName"
            :disabled="item.id == shopId"
          ></el-option>
        </el-select>
      </div>
      <r-table
        :columns="tableColumn"
        :dataSource="targetDataList"
        :options="rtableOptions"
        :showPagination="false"
        @selection-change="handleRightSelectChange"
      >
      </r-table>
    </div>
  </div>
  <div class="align-c m-t-20 p-t-10">
    <el-button class="submit-btn" @click="handleSave">确定</el-button>
    <el-button class="cancel-btn" @click="handleCancel">取消</el-button>
  </div>
</template>

<script>
import RTable from '@/components/common/RTable'
import tableMix from '@/components/common/tableListMixin.js'
import { mapActions } from "vuex";
export default {
  components: { RTable },
  mixins: [tableMix],
  props: ['shopId', 'moveStoreName'],
  emits: ['close'],
  data() {
    return {
      currentRoomType: null,
      currentStoreId: null,
      roomTypeList: [],
      roomDataList: [],
      sourceDataList: [],
      targetDataList: [],
      storeDataList: [],
      tableColumn: [],
      sourceTableSelection: [],
      targetTableSelection: [],
      options: { selection: [], calculateHeight: false, height: '350px' },
      rtableOptions: { selection: [], calculateHeight: false, height: '390px' }
    }
  },
  watch: {
    shopId(){
      this.init();
    },
  },
  created() {
    this.init();
  },

  methods: {
    ...mapActions(["fetchData"]),

    init(){
      this.targetDataList = [];
      this.currentStoreId = null;
      this.getRoomList();
      this.getRoomType();
      this.getSotreList();
      this.initTableColumn();
    },

    // 获取当前门店下的房型
    getRoomType() {
      if (!this.shopId) return;
      let url = 'ROOM.TYPE.GET_LIST'
      this.fetchData({
        url,
        method: 'get',
        params: { storeId: this.shopId }
      }).then(res => {
        this.roomTypeList = res && res.data || [];

      })
    },

    // 获取房型下的房源
    getRoomList(roomTypeId) {
      if (!this.shopId) return;
      let params = {
        storeId: this.shopId,
        pageNumber: 1,
        pageSize: 9999
      }
      roomTypeId && (params.roomTypeId = roomTypeId);
      this.fetchData({
        url: 'SAAS.ROOM_MOVE_LIST',
        method: 'get',
        params
      }).then(res => {
        
        this.sourceDataList = res || [];
        console.log(res,this.sourceDataList,'=dd===========')
        this.roomDataList = JSON.parse(JSON.stringify(this.sourceDataList));
      })
    },

    // 获取门店列表
    getSotreList() {
      let url = 'SHOP.GET_LIST'
      this.fetchData({
        url,
        method: 'get'
      }).then(res => {
        this.storeDataList = res?.data || [];
      })
    },

    // 初始化table
    initTableColumn() {
      this.tableColumn = [
        { prop: 'roomTypeName', label: '房型' },
        { prop: 'roomName', label: '房源名称' }
      ]
    },

    // 房型变更
    roomTypeChange() {
      this.roomDataList = this.sourceDataList.filter(item => {
        if (this.currentRoomType) {
          return item.roomTypeId === this.currentRoomType
        } else {
          return item.roomTypeId
        }
      });
    },

    // 保存
    handleSave() {
      if (!this.targetDataList.length) {
        this.handleCancel()
      } else {
        if (!this.currentStoreId) {
          this.$message.warning('请选择要迁移的目标门店')
          return;
        }
        this.fetchData({
          url: 'SAAS.ROOM_CHANGE_STORE',
          method: 'post',
          headers: { 'Content-Type': 'application/json' },
          params: { roomIdList: this.targetDataList.map(item => item.id), targetStoreId: this.currentStoreId, sourceStoreId: 0 }
        }).then(res => {
          if (res && res.status == 1) {
            this.$message.success('操作成功')
            this.init();
            this.handleCancel(true)
          } else {
            this.$message.error(res.msg || '操作失败')
          }
        }).catch(() => {
          this.$message.error('操作失败')
        })
      }
    },

    // 关闭对话框
    handleCancel(success) {
      this.$emit('close', success)
    },

    // 左侧table选择变更
    handleLeftSelectChange(selection) {
      this.sourceTableSelection = selection
    },

    // 右侧table选择变更
    handleRightSelectChange(selection) {
      this.targetTableSelection = selection
    },

    // 添加
    addItem() {
      if (!this.sourceTableSelection.length) return;
      this.targetDataList = this.targetDataList.concat(this.sourceTableSelection);
      this.sourceDataList = this.sourceDataList.filter(item => !(this.targetDataList.find(_item => _item.id === item.id)))
      this.roomDataList = this.roomDataList.filter(item => !(this.sourceTableSelection.find(_item => _item.id === item.id)))
      this.sourceTableSelection = [];
    },

    // 移除
    delItem() {
      if (!this.targetTableSelection.length) return;
      this.sourceDataList = this.sourceDataList.concat(this.targetTableSelection);
      this.roomDataList = this.sourceDataList;
      this.targetDataList = this.targetDataList.filter(item => !(this.targetTableSelection.find(_item => _item.id === item.id)))
      this.targetTableSelection = [];
      this.currentRoomType = null;
    },
  },

}
</script>

<style lang="less" scoped>
.move-house-modal {
  display: flex;
  @operationsWidth: 120px;
  @sideWidth: calc((100% - @operationsWidth) / 2);
  .operations{
    display: flex;
    flex-direction: column;
    width: @operationsWidth;
  }
  .source-view {
    min-width: @sideWidth;
    .store-info {
      background-color: #f1f8f9;
      border-radius: 8px 8px 0 0;
    }
  }
  .filter-view {
    display: flex;
    align-items: center;
    .el-select {
      flex: 1;
    }
  }
  .c-operate {
    p {
      cursor: pointer;
      color: rgba(0, 192, 192, 1);
      &.disabled {
        cursor: not-allowed;
      }
    }
  }
  .target-view {
    min-width: @sideWidth;
  }
  :deep(.r-pagination) {
    .demonstration {
      opacity: 0;
    }
    .el-pagination__sizes {
      opacity: 0;
    }
  }
}
</style>